/* Wonky cart: AJAX add, drawer render, pack-progress nudge. No frameworks. */
(function () {
  /* Server renders prices via the money filter; JS updates must match whatever format the shop uses. */
  var MONEY = window.WonkyMoney || '${{amount}}';
  var fmt = function (cents) { return MONEY.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)); };

  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };

  var _focusOrigin = null;

  function openDrawer() {
    document.body.classList.add('drawer-open');
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    _focusOrigin = document.activeElement;
    var closeBtn = document.querySelector('.drawer [data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    document.body.classList.remove('drawer-open');
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    if (_focusOrigin && _focusOrigin.isConnected) { _focusOrigin.focus(); }
    _focusOrigin = null;
  }

  function nudgeHtml(count) {
    var pct = count >= 5 ? 100 : count >= 3 ? Math.round(60 + ((count - 3) / 2) * 40) : Math.round((count / 3) * 60);
    var msg;
    if (count >= 5) {
      msg = '20% off applied at checkout. The whole wonky family approves.';
    } else if (count >= 3) {
      msg = '✓ 15% off unlocked at checkout! Add ' + (5 - count) + ' more for 20% · <a href="/#cast" data-drawer-browse>Pick ' + (5 - count) + ' more →</a>';
    } else if (count > 0) {
      msg = 'Add ' + (3 - count) + ' more — packs of 3 save 15% · <a href="/#cast" data-drawer-browse>Pick ' + (3 - count) + ' more →</a>';
    } else {
      msg = 'Packs of 3 save 15% · packs of 5 save 20% · <a href="/#cast" data-drawer-browse>Meet the cast →</a>';
    }
    return '<div class="pack-nudge-msg">' + msg + '</div>' +
      '<div class="pack-meter" aria-hidden="true"><span class="pack-meter-fill" style="width:' + pct + '%"></span></div>';
  }

  function renderCart(cart) {
    var pill = document.querySelector('.cart-pill');           /* spec §4: bounce on add */
    if (pill) {
      pill.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 250 });
    }
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = fmt(cart.total_price); });
    var nudge = document.querySelector('[data-pack-nudge]');
    if (nudge) { nudge.hidden = false; nudge.innerHTML = nudgeHtml(cart.item_count); }
    var box = document.querySelector('[data-drawer-items]');
    if (!box) return;
    box.innerHTML = cart.items.map(function (it, i) {
      var thumb = it.image ? it.image + (it.image.indexOf('?') !== -1 ? '&' : '?') + 'width=128' : '';
      return '<div class="drawer-line">' +
        (it.image ? '<img src="' + esc(thumb) + '" alt="">' : '') +
        '<div><strong>' + esc(it.product_title) + '</strong><br><small>' + esc(it.variant_title) + '</small></div>' +
        '<span class="qty">×' + it.quantity + '</span>' +
        '<button class="drawer-remove" type="button" data-cart-remove="' + (i + 1) + '" aria-label="Remove ' + esc(it.product_title) + '">✕</button>' +
        '</div>';
    }).join('') || '<p>Empty. Tragic.</p>';
  }

  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { refresh().then(openDrawer); }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); }
    var browse = e.target.closest('[data-drawer-browse]');
    if (browse) {
      var target = document.getElementById('more-cast') || document.getElementById('cast');
      if (target) {
        e.preventDefault();
        closeDrawer();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      remove.disabled = true;
      var line = remove.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 }),
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () { remove.disabled = false; });
      return;
    }
    var pill = e.target.closest('.size-pill');
    if (pill) {
      if (pill.tagName === 'A') return; /* COVER link navigates; not a variant toggle */
      var card = pill.closest('[data-card]');
      if (!card) return;
      card.querySelectorAll('.size-pill').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
      pill.setAttribute('aria-pressed', 'true');
      var idInput = card.querySelector('[name="id"]');
      if (idInput) idInput.value = pill.dataset.variantId;
      var priceEl = card.querySelector('.price');
      if (priceEl && pill.dataset.price) priceEl.textContent = fmt(parseInt(pill.dataset.price, 10));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-wonky-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh().catch(function () {}); /* add succeeded; a failed refresh must not read as a failed add */
      })
      .then(openDrawer)
      .catch(function () {
        /* the button holds the +/price markup — flash the error, then put it back */
        var original = btn.innerHTML;
        btn.textContent = 'Try again';
        setTimeout(function () { if (btn.isConnected) btn.innerHTML = original; }, 2400);
      })
      .finally(function () { btn.disabled = false; });
  });
})();

/* PDP gallery: thumbnails swap the main photo; main photo zooms under the cursor. */
(function () {
  var zoomBox = document.querySelector('[data-pdp-zoom]');
  if (!zoomBox) return;
  var main = zoomBox.querySelector('[data-pdp-main]');

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp-thumb');
    if (!thumb || !main) return;
    main.src = thumb.dataset.src;
    main.srcset = thumb.dataset.srcset;
    main.alt = thumb.dataset.alt || '';
    document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
    thumb.setAttribute('aria-pressed', 'true');
  });

  /* Variant-aware gallery: front/back renders follow the selected size. */
  var galleryNode = document.querySelector('[data-pdp-gallery]');
  if (galleryNode) {
    var gallery = {};
    try { gallery = JSON.parse(galleryNode.textContent); } catch (_) {}
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.pdp .size-pill[data-variant-id]');
      if (!pill) return;
      var entry = gallery[pill.dataset.variantId];
      if (!entry) return;
      ['front', 'back'].forEach(function (role) {
        var thumb = document.querySelector('.pdp-thumb[data-role="' + role + '"]');
        if (!thumb || !entry[role]) return;
        thumb.dataset.src = entry[role].src;
        thumb.dataset.srcset = entry[role].srcset;
        var img = thumb.querySelector('img');
        if (img) img.src = entry[role].thumb;
        if (main && thumb.getAttribute('aria-pressed') === 'true') {
          main.src = entry[role].src;
          main.srcset = entry[role].srcset;
        }
      });
    });
  }

  /* Zoom origin follows the cursor; the scale itself lives in CSS (hover-capable, motion-safe only). */
  zoomBox.addEventListener('mousemove', function (e) {
    if (!main) return;
    var rect = zoomBox.getBoundingClientRect();
    var x = ((e.clientX - rect.left) / rect.width) * 100;
    var y = ((e.clientY - rect.top) / rect.height) * 100;
    main.style.transformOrigin = x + '% ' + y + '%';
  });
})();

/* Hero rotator: cross-fade through the cast's travel shots; each slide links to its pillow. */
(function () {
  var stage = document.querySelector('[data-hero-rotator]');
  if (!stage) return;
  var slides = stage.querySelectorAll('[data-hero-slide]');
  if (slides.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var current = 0;
  var interval = parseInt(stage.dataset.interval, 10) || 6000;
  var paused = false;

  stage.addEventListener('mouseenter', function () { paused = true; });  /* don't swap the link out from under the cursor */
  stage.addEventListener('mouseleave', function () { paused = false; });
  stage.addEventListener('focusin', function () { paused = true; });
  stage.addEventListener('focusout', function () { paused = false; });

  setInterval(function () {
    if (paused || document.hidden) return;
    var prev = slides[current];
    current = (current + 1) % slides.length;
    var next = slides[current];
    prev.classList.remove('is-active');
    prev.setAttribute('aria-hidden', 'true');
    prev.setAttribute('tabindex', '-1');
    next.classList.add('is-active');
    next.removeAttribute('aria-hidden');
    next.removeAttribute('tabindex');
  }, interval);
})();
